module.exports = __webpack_public_path__ + "img/7.b8fb0c28.png";